import React from 'react';
import ReactDOM from 'react-dom';
import IndexRouters from './routes/routes';
import { Provider as ReduxProvider } from 'react-redux';
import { persistor, store } from './state/store';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import GlobalStyle from './styles/globalStyles';
import '../node_modules/react-toastify/dist/ReactToastify.css';
import { GanttProvider } from './hooks/useGantt';
import { AuthProvider as AuthCheckProvider } from './auth/AuthContext';
import { PersistGate } from 'redux-persist/integration/react';
import { Notifications } from './components/Notifications';

const jsx = (
  <BrowserRouter>
    <GlobalStyle />
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthCheckProvider>
          <GanttProvider>
            <ToastContainer position="top-right" autoClose={2000} />
            <IndexRouters />
            <Notifications />
          </GanttProvider>
        </AuthCheckProvider>
      </PersistGate>
    </ReduxProvider>
  </BrowserRouter >
);

ReactDOM.render(jsx, document.getElementById('root'));
